<app-header></app-header>
<div id="pageMainContainer" class="container-fluid">
    <router-outlet></router-outlet>
</div>
<!--<app-footer></app-footer>-->